import { render, staticRenderFns } from "./combo-card.vue?vue&type=template&id=2dc8449c&scoped=true"
import script from "./combo-card.vue?vue&type=script&lang=js"
export * from "./combo-card.vue?vue&type=script&lang=js"
import style0 from "./combo-card.vue?vue&type=style&index=0&id=2dc8449c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8449c",
  null
  
)

export default component.exports